export const VIEWPORT_CONFIG = {
  RESIZE_DEBOUNCE: 250,
  SCROLL_DEBOUNCE: 100,
  INTERSECTION_THRESHOLDS: [0, 0.25, 0.5, 0.75, 1],
  ROOT_MARGIN: '0px',
  STICKY_POSITION_THRESHOLD: 5,
};
